var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.33334 3.32642C3.33334 2.67898 3.33334 2.35526 3.46834 2.17681C3.58594 2.02135 3.76569 1.92515 3.96028 1.91353C4.18363 1.9002 4.45299 2.07977 4.99169 2.4389L12.0021 7.11248C12.4472 7.40923 12.6697 7.55761 12.7473 7.74462C12.8151 7.90813 12.8151 8.09188 12.7473 8.25538C12.6697 8.4424 12.4472 8.59077 12.0021 8.88752L4.99169 13.5611C4.45299 13.9202 4.18363 14.0998 3.96028 14.0865C3.76569 14.0749 3.58594 13.9787 3.46834 13.8232C3.33334 13.6447 3.33334 13.321 3.33334 12.6736V3.32642Z",
    stroke: "#039855",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/play-video-icon.f99ede632fef84dd158fb78993e694f2.svg";
export { ForwardRef as ReactComponent };